import gql from 'graphql-tag';

export const CREATE_CHARITY_MUTATION = gql`
  mutation createCharity($charityInputDetails: CharityInput!) {
    createCharity(charityInput: $charityInputDetails) {
      id
      testatorId
      name
      registrationNumber
      displayName
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const UPDATE_CHARITY_MUTATION = gql`
  mutation updateCharity($id: ID!, $charityInputDetails: CharityInput!) {
    updateCharity(id: $id, charityInput: $charityInputDetails) {
      id
      testatorId
      name
      registrationNumber
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const DELETE_CHARITY_MUTATION = gql`
  mutation deleteCharity($id: ID!) {
    deleteCharity(id: $id) {
      id
    }
  }
`;
